import { Component, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { IntersectionAnimateDirective } from '../../directives/intersection-animate.directive';

@Component({
  selector: 'app-member-card',
  imports: [RouterLink, IntersectionAnimateDirective],
  templateUrl: './member-card.html',
  styleUrl: './member-card.scss',
})
export class MemberCard {
  name = input<string>();
  position = input<string>();
  image = input<string>();
  odd = input<boolean>(false);
  isAnimate = input<boolean>(true);
  link = input<string>();
  recommended = input<boolean>(false);
  icon = input<string | null>(null);
  tags = input<any[]>([]);
}
